import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_177ec162-a789-4cad-ab14-accead9ebd01/artifacts/53213un4_Logo%20Meraki.png";

const Loader = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          setTimeout(onComplete, 500);
          return 100;
        }
        return prev + 2;
      });
    }, 30);

    return () => clearInterval(interval);
  }, [onComplete]);

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
        className="fixed inset-0 z-[9999] bg-[#050505] flex flex-col items-center justify-center"
        data-testid="loader"
      >
        {/* Animated background particles */}
        <div className="absolute inset-0 overflow-hidden">
          {[...Array(20)].map((_, i) => (
            <motion.div
              key={i}
              className="absolute w-1 h-1 bg-[#D91616]/30 rounded-full"
              initial={{
                x: Math.random() * window.innerWidth,
                y: Math.random() * window.innerHeight,
              }}
              animate={{
                y: [null, Math.random() * -500],
                opacity: [0, 1, 0],
              }}
              transition={{
                duration: Math.random() * 3 + 2,
                repeat: Infinity,
                ease: "linear",
              }}
            />
          ))}
        </div>

        {/* Logo with pulse animation */}
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="relative"
        >
          <motion.div
            animate={{ 
              boxShadow: [
                "0 0 20px rgba(217, 22, 22, 0.3)",
                "0 0 60px rgba(217, 22, 22, 0.6)",
                "0 0 20px rgba(217, 22, 22, 0.3)",
              ]
            }}
            transition={{ duration: 2, repeat: Infinity }}
            className="p-8"
          >
            <img 
              src={LOGO_URL} 
              alt="MERAKI" 
              className="h-20 w-auto"
            />
          </motion.div>
        </motion.div>

        {/* Progress bar */}
        <div className="mt-12 w-64">
          <div className="h-[2px] bg-white/10 overflow-hidden">
            <motion.div
              className="h-full bg-gradient-to-r from-[#D91616] to-[#ED1C24]"
              initial={{ width: 0 }}
              animate={{ width: `${progress}%` }}
              transition={{ duration: 0.1 }}
            />
          </div>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-center mt-4 text-xs text-zinc-500 uppercase tracking-[0.3em]"
          >
            {progress < 100 ? 'Loading Experience...' : 'Welcome'}
          </motion.p>
        </div>

        {/* Decorative corners */}
        <div className="absolute top-8 left-8 w-16 h-16 border-l-2 border-t-2 border-[#D91616]/30" />
        <div className="absolute top-8 right-8 w-16 h-16 border-r-2 border-t-2 border-[#D91616]/30" />
        <div className="absolute bottom-8 left-8 w-16 h-16 border-l-2 border-b-2 border-[#D91616]/30" />
        <div className="absolute bottom-8 right-8 w-16 h-16 border-r-2 border-b-2 border-[#D91616]/30" />
      </motion.div>
    </AnimatePresence>
  );
};

export default Loader;
